import { Worksheet } from "exceljs";
import { tx as tc } from "./excel-util";

export const tx = (
  col: string,
  value: any,
  worksheet: Worksheet,
  row: number,
  t: any
) => {
  tc(col, value, worksheet, row, t);
};
